import { withI18n } from 'lingui-react';
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import { compose, setDisplayName } from 'recompose';

import Page from 'blocks/Page';

import Dealers from 'compositions/TechAdmin/Dealers';

import { pageTitles, pageMeta } from '../../constants';

function DealersPage({ i18n }) {
  return (
    <Page modifiers={['bgChrome100', 'flex_column', 'fluid', 'height_100']}>
      <Helmet>
        <title>{i18n._(pageTitles.techAdminDealerList)}</title>
        <meta
          name="description"
          content={i18n._(pageMeta.techAdminDealerList)}
        />
      </Helmet>
      <Dealers />
    </Page>
  );
}

DealersPage.propTypes = {
  i18n: PropTypes.shape({
    _: PropTypes.func.isRequired,
  }).isRequired,
};

export default compose(
  setDisplayName('DealersPage'),
  withI18n(),
)(DealersPage);



// WEBPACK FOOTER //
// ./src/pages/TechAdmin/Dealers/index.js